module.exports = __webpack_public_path__ + "static/media/icon_03.5b6224cc.svg";